import { ORDER_METHODS } from '../../../../../services/exports/Constants';

export default {
  empty_list: 'Ingen produkter endnu.',
  fields: {
    number: '#',
    image: 'Billede',
    name: 'Navn',
    external_id: '{{integration}}-ref.',
    price: 'Pris',
    prices: 'Priser',
    description: 'Beskrivelse',
    tags: 'Tags',
    status: 'Status',
    product_type: 'Type',
    statuses: {
      good: 'God',
      bad: 'Dårlig',
      medium: 'Middel',
    },
    product_types: {
      packaged: 'Pakket',
      prepared: 'Tilberedt',
    },
  },
  labels: {
    visible: 'Synlig i menuen',
    hidden: 'Alle skjult',
  },
  order_method_prices: {
    base: 'Basis',
    [ORDER_METHODS.pickup]: 'Afhentning',
    [ORDER_METHODS.delivery]: 'Levering',
    [ORDER_METHODS.room_service]: 'Værelses-/bordservice',
  },
  buttons: {
    delete_products_one: 'Slet produkt',
    delete_products_other: 'Slet produkter',
    add_product: '+ Tilføj produkt',
    show_products: 'Vis produkter',
    hide_products: 'Skjul produkter',
    add: 'Tilføj',
    edit: 'Rediger',
    duplicate: 'Dupliker',
    history: 'Historik',
    delete: 'Slet',
    delete_all: 'Slet alle',
  },
  toasts: {
    failed_to_duplicate_category: 'Kategorien kunne ikke duplikeres',
    category_duplicated_successfully: 'Kategorien er duplikeret',
    failed_to_duplicate_product: 'Produktet kunne ikke duplikeres',
    product_duplicated_successfully: 'Produktet er duplikeret',
    failed_to_delete_variant: 'Varianten kunne ikke slettes',
    variant_got_deleted: 'Varianten er slettet',
    something_went_wrong: 'Noget gik galt',
  },
};
